import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaTimes } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var Multiply = createPlugin({
    protocol: 'TOKEN_MATH',
    type: 'CALCULATOR',
    method: 'mul',
    description: 'Multiply amount1 and amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                numerator: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaTimes }),
                decimals1: new FctDecimals({}),
                factor: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                innerIndex: 0,
            }),
        },
    }); },
});
